/**
 * Change title depending on category
 */

const changeTitle = (categ:any) => {
  console.log(categ);

  document.title = categ + '｜田んぼの雑草図鑑';
};

export default changeTitle;
